import React, { useContext, useState, useEffect } from "react";
import ProductItem from "./ProductItem";
import { StoreContext } from "../../context/StoreContext";
import SearchContext from "../../context/SearchContext";
import { decodeHTMLEntities } from "../../util/validate";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tab,
  TableContainer,
  Paper,
  Box,
} from '@mui/material';
import SummaryBar from "./SummaryBar";
import CartContext from "../../context/CartContext";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { motion, AnimatePresence } from 'framer-motion';

const ProductList = () => {
  const { data } = useContext(StoreContext);
  const searchCtx = useContext(SearchContext);
  const cartCtx = useContext(CartContext);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      const isMobile = window.innerWidth <= 768;
      const fallbackHeight = isMobile ? 400 : 850;

      const topHeader = document.querySelector(".marquee-container");
      const header = document.querySelector(".header-app-bar");
      const banner = document.querySelector(".banner-container");
      const SummaryBar=document.querySelector(".summary-bar");
      const SummaryBox=document.querySelector(".summary-box");

      const threshold =
        (topHeader?.offsetHeight || 0) +
        (header?.offsetHeight || 0) +
        (banner?.offsetHeight || 0) +
        (SummaryBar?.offsetHeight || 0) +
        (SummaryBox?.offsetHeight || 0) ||
        fallbackHeight;
      
      if (offset > threshold) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const productsList = data.product_master.filter((value) =>
    decodeHTMLEntities(value.productname).toLowerCase().includes(searchCtx.searchValue.toLowerCase())
  );

  let listOfCategories = productsList.map((item) =>
    decodeHTMLEntities(item.categoryname)
  );

  listOfCategories = listOfCategories
    .sort()
    .filter((v, i) => listOfCategories.indexOf(v) === i);

  const initialOpenState = listOfCategories.reduce((acc, cat) => {
    acc[cat] = true;
    return acc;
  }, {});

  const [openCategories, setOpenCategories] = useState(initialOpenState);

  const toggleCategory = (category) => {
    setOpenCategories(prevState => ({
      ...prevState,
      [category]: !prevState[category]
    }));
  };

  return (
    <div className="list-view">
      <SummaryBar cartItems={cartCtx.items} />

      {productsList.length > 0 ? (
        <>
          <TableContainer component={Paper} sx={{
            width: "100%",
            boxShadow: "none",
          }}>
            <Table stickyHeader className="product-table">
              <TableHead className={`product-table-head ${isSticky ? "sticky" : ""}`}
                sx={{
                  backgroundColor: "#FFEEE8",
                  zIndex: isSticky ? 2 : 1,
                  '& > *': { border: 'none' }
                }}>
                <TableRow className="product-row">
                  <TableCell className="cell-image table-header-cell" sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, position: "sticky", top: 48, zIndex: 2, background: '#FFEEE8', }} >IMAGE</TableCell>
                  <TableCell className="cell-name table-header-cell" sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, position: "sticky", top: 48, zIndex: 2, background: '#FFEEE8', }}>PRODUCT NAME</TableCell>
                  <TableCell className="cell-price table-header-cell" sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, position: "sticky", top: 48, zIndex: 2, background: '#FFEEE8', }}>PRICE</TableCell>
                  <TableCell className="cell-action table-header-cell" sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, position: "sticky", top: 48, zIndex: 2, background: '#FFEEE8', }}>ACTION</TableCell>
                  <TableCell className="cell-subtotal table-header-cell" sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, position: "sticky", top: 48, zIndex: 2, background: '#FFEEE8', }}>SUB TOTAL</TableCell>
                </TableRow>
              </TableHead>
              {isSticky && (
                <TableRow
                  sx={{
                    height: "48px",
                    visibility: "hidden",
                  }}
                >
                  <TableCell colSpan={5} />
                </TableRow>
              )}
              <TableBody>
                {listOfCategories.map((cat) => (
                  <React.Fragment key={cat || "others"}>
                    <TableRow
                      sx={{
                        cursor: 'pointer',
                        justifyContent: 'flex-start',
                      }}
                      onClick={() => toggleCategory(cat)}
                    >
                      <TableCell
                        colSpan={5}
                        className="category-border"
                        sx={{
                          padding: '16px',
                          paddingRight: '40px',
                          position: 'relative',
                        }}
                      >
                        <span className="category-label">
                          {cat || "Others"}
                        </span>
                        {openCategories[cat] ? (
                          <IoMdArrowDropup className="dropdown-icon" size={24} style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', color: 'white' }} />
                        ) : (
                          <IoMdArrowDropdown className="dropdown-icon" size={24} style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', color: 'white' }} />
                        )}
                      </TableCell>
                    </TableRow>
                    <AnimatePresence>
                      {openCategories[cat] && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: 'auto', opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.3, ease: 'easeInOut' }}
                          style={{ overflow: 'hidden' }}
                        >
                          {productsList
                            .filter((item) => decodeHTMLEntities(item.categoryname) === decodeHTMLEntities(cat))
                            .map((item) => (
                              <ProductItem key={item.id} product={item} />
                            ))}
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <div className="not-found-text">Couldn’t find items</div>
      )}

    </div>
  );
};

export default ProductList;